"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HorizontalLine = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var colorLine = {
    primary: ['br-border-blue-500'],
    gray: ['br-border-gray-400'],
    orange: ['br-border-orange-500'],
    red: ['br-border-red-500'],
    blueGray: ['br-text-[#AEBFD4]']
};
var HorizontalLine = function (_a) {
    var className = _a.className, type = _a.type, _b = _a.spaceWidth, spaceWidth = _b === void 0 ? 1 : _b;
    var cns = colorLine[type];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("hr", { className: (0, classnames_1.default)({
                // HEIGHT
                'br-my-1': spaceWidth === 1,
                'br-my-2': spaceWidth === 2,
                'br-my-3': spaceWidth === 3,
                'br-my-4': spaceWidth === 4,
                'br-my-5': spaceWidth === 5,
                'br-my-6': spaceWidth === 6,
                'br-my-8': spaceWidth === 8,
                'br-my-10': spaceWidth === 10
            }, className, cns) })));
};
exports.HorizontalLine = HorizontalLine;
